import React from 'react';
import { AnalyzerIcon } from '@Components/UI/Icons';
import styled from 'styled-components';
import style from './StartPage.style';
import mixpanelEvents from '@Mixpanel';

const StartPage = ({ className }) => {
    mixpanelEvents.startPageDisplayed();

    return (
        <div className={className}>
            <h1>
                <AnalyzerIcon />
            </h1>
            <p>Get started with advanced contract analytics</p>
        </div>
    );
};

export default styled(StartPage)`
    ${style};
`;
